import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const MessageSkeleton = () => (
  <Box
    component="li"
    cursor="pointer"
    background={'grey000White'}
    paddingY="s12"
    paddingX="s16"
    gap="s12"
  >
    <Box flexDirection="row" gap="s16" justifyContent="spaceBetween" alignItems="center">
      <Box flexDirection="row" gap="s8" alignItems="center" flexGrow>
        <Skeleton width="s200" height="s16" />
      </Box>
      <Skeleton width="s64" height="s16" />
    </Box>
    <Skeleton width="s120" height="s16" />
    <Box paddingTop="s4" maxHeight="s48" gap="s12">
      <Skeleton width="s300" height="s16" />
      <Skeleton width="s240" height="s16" />
    </Box>
  </Box>
)

export default MessageSkeleton
